import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Styled = styled.span`
  font-weight: bold;

  a:hover {
    text-decoration: underline;
  }

  @keyframes hue {
    0% {
      filter: hue-rotate(0deg);
    }
    50% {
      filter: hue-rotate(179deg);
    }
    100% {
      filter: hue-rotate(357deg);
    }
  }

  a {
    animation: ${({ rainbow }) =>
      rainbow ? 'hue 2s infinite alternate' : 'none'};
  }
`;

function ColorLink({ color, to, children, rainbow, ...other }) {
  const isInner = to[0] === '/';

  return (
    <Styled rainbow={rainbow}>
      {isInner ? (
        <Link to={to} style={{ color }} {...other}>
          {children}
        </Link>
      ) : (
        <a href={to} style={{ color }} {...other}>
          {children}
        </a>
      )}
    </Styled>
  );
}

ColorLink.propTypes = {
  color: PropTypes.string,
  to: PropTypes.string,
  rainbow: PropTypes.bool,
  children: PropTypes.any.isRequired,
};

ColorLink.defaultProps = {
  color: 'black',
  to: '/',
  rainbow: false,
};

export default ColorLink;
